var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from "react";
function SvgMoon(passedProps, svgRef) {
    var props = __assign({}, passedProps);
    return (React.createElement("svg", __assign({ width: "1.5em", height: "1.5em", viewBox: "0 0 31 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", color: "currentColor", ref: svgRef }, props),
        React.createElement("path", { d: "M13.494 4.64a8.277 8.277 0 00-4.5 7.36c0 4.594 3.656 8.25 8.203 8.25.61 0 1.219-.047 1.828-.188a10.5 10.5 0 01-7.078-9.937c0-2.016.563-3.89 1.547-5.484zM16.4 1.548H18.088c.328.047.61.281.656.61a.67.67 0 01-.328.796 4.119 4.119 0 00-.469.281l-.562.422a.645.645 0 00-.188.14 8.223 8.223 0 00-3 6.376c0 4.547 3.703 8.203 8.203 8.25h.187c.282-.047.517-.047.75-.047.142-.047.329-.047.517-.094.328-.047.656.094.796.375.141.328.094.657-.14.89-.14.142-.235.235-.375.329-.235.188-.422.375-.657.563-.093.046-.187.14-.28.187a10.476 10.476 0 01-6 1.875c-5.766 0-10.454-4.688-10.454-10.5 0-5.531 4.266-10.031 9.656-10.453z", fill: "#242B42" })));
}
var ForwardRef = React.forwardRef(SvgMoon);
export default ForwardRef;
